<div class="inquiry-teaser inquiry-calendar-container inquiry-shift-view-calendar p-0">
  <div class="d-flex flex-column inquiry-left-content">
    <div class="d-flex align-items-center inquiry-info ps-4">
      <base-inquiries-calendar-meta
        [datesQty]="calendarDatesList.length"
        [isCustomisedTooltip]="true"
      ></base-inquiries-calendar-meta>
    </div>
    <div
      class="inquiry-calendar-shift-times ps-4 d-flex flex-column flex-grow-1 align-items-stretch justify-content-around"
    >
      <div class="d-flex justify-content-end">
        <span class="d-flex align-items-center inquiry-shift-time inquiry-shift-time-flex">
          <span class="d-xl-block text-uppercase text-dark-blue">
            {{ 'inquiry.flexibleShifts' | translate }}
          </span>
        </span>
      </div>

      <div
        class="d-flex justify-content-between align-items-center"
        *ngFor="let shiftTime of timeShiftsForm.getRawValue(); trackBy: trackByShiftTime"
      >
        <div>
          <span class="inquiry-shift-time-range"> {{ shiftTime.startTime }} - {{ shiftTime.endTime }} </span>

          <i
            class="fa-pen fa-solid pointer small"
            (click)="openEditShiftTimesModal(shiftTime.type)"
          ></i>
        </div>
        <span class="d-flex align-items-center inquiry-shift-time">
          <span class="d-xl-block text-uppercase text-dark-blue">
            {{ shiftTime.type | translate }}
          </span>
          <i class="ms-2 fa-fw fa-regular text-dark-blue {{ baseShiftIconsEnum[shiftTime.type] }}"></i>
        </span>
      </div>
    </div>
  </div>

  <div class="inquiry-right-content calendar-days-container">
    <base-customer-shift-plan-dates-list
      class="d-flex w-100"
      [timeShifts]="timeShiftsForm.getRawValue()"
    ></base-customer-shift-plan-dates-list>
  </div>
</div>

<ng-template #editTimeShifts>
  <base-customer-edit-shift-view-modal
    [parentForm]="editInquiryForm"
    [modalRef]="timeShiftsModalRef"
    [activeShiftType]="activeShiftType"
  ></base-customer-edit-shift-view-modal>
</ng-template>
